import { render, staticRenderFns } from "./RegistroHistorico.html?vue&type=template&id=5f86a72c&external"
import script from "./RegistroHistorico.vue?vue&type=script&lang=js"
export * from "./RegistroHistorico.vue?vue&type=script&lang=js"
import style0 from "./RegistroHistorico.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports